export default function getScalingParameters(metaData, imageId) {
    const modalityLutModule = metaData.get('modalityLutModule', imageId) || {};
    const generalSeriesModule = (metaData.get('generalSeriesModule', imageId) ||
        {});
    const { modality } = generalSeriesModule;
    const rescaleSlope = modalityLutModule.rescaleSlope;
    const rescaleIntercept = modalityLutModule.rescaleIntercept;
    const scalingModules = metaData.get('scalingModule', imageId) || {};
    const hasPTScaling = modality === 'PT' &&
        typeof scalingModules.suvbw === 'number' &&
        !isNaN(scalingModules.suvbw);
    const hasDoseScaling = modality === 'RTDOSE' &&
        typeof scalingModules.DoseGridScaling === 'number' &&
        !isNaN(scalingModules.DoseGridScaling);
    if (rescaleSlope === 1 &&
        (rescaleIntercept === 0 || rescaleIntercept == null) &&
        !hasPTScaling &&
        !hasDoseScaling) {
        return undefined;
    }
    const scalingParameters = {
        rescaleSlope: rescaleSlope ?? 1,
        rescaleIntercept: rescaleIntercept ?? 0,
        modality,
    };
    return {
        ...scalingParameters,
        ...(modality === 'PT' && { suvbw: scalingModules.suvbw }),
        ...(modality === 'RTDOSE' && {
            doseGridScaling: scalingModules.DoseGridScaling,
            doseSummation: scalingModules.DoseSummation,
            doseType: scalingModules.DoseType,
            doseUnit: scalingModules.DoseUnit,
        }),
    };
}
